<dialog-draggable-header>ECM Reports</dialog-draggable-header>

<div class="reports-container">
  <div class="left-container">
    <div id="tools-header">
      Tools
    </div>
    <div>
      <p-listbox [options]="tools" optionLabel="toolNo" [multiple]="true" [listStyle]="{'height':'350px'}"
        [style]="{'width':'auto','margin-right':'1em'}" [(ngModel)]="selectedTools"></p-listbox>
    </div>
  </div>
  <div class="right-container">
    <div id="report-criteria-header">
      Select Report Criteria
    </div>
    <div class="filter">
      <span class="h4">Design Source</span>
      <p-dropdown styleClass="dropdown-height" [options]="designSources" optionLabel="sourceName"
        [disabled]="!designSourcesEnabled" [(ngModel)]="designSourcesSelected" (onChange)="updateTools()"
        placeholder=" ">
      </p-dropdown>
      <p-checkbox [binary]="true" [(ngModel)]="designSourcesEnabled"></p-checkbox>
    </div>
    <div class="filter">
      <span class="h4">Program</span>
      <p-dropdown styleClass="dropdown-height" [options]="programSources" optionLabel="programNameYear"
        [disabled]="!programEnabled" [(ngModel)]="programSelected" (onChange)="updateTools()" placeholder=" "
        [virtualScroll]="true">
      </p-dropdown>
      <p-checkbox [binary]="true" [(ngModel)]="programEnabled"></p-checkbox>
    </div>
    <div class="filter">
      <span class="h4">Engineer</span>
      <p-dropdown styleClass="dropdown-height" [options]="engineerSources" optionLabel="lastFirstName"
        [disabled]="!engineerEnabled" [(ngModel)]="engineerSelected" (onChange)="updateTools()" placeholder=" "
        [virtualScroll]="true">
      </p-dropdown>
      <p-checkbox [binary]="true" [(ngModel)]="engineerEnabled"></p-checkbox>
    </div>

    <!-- TEXT SECTION -->
    <div class="text-section">
      <p>To select a Tool: click the Tool Number.</p>
      <p>To select more than one Tool: click the ctrl key, then the Tool Number(s)</p>
      <p>To de-select a Tool: click the ctrl key then the Tool Number.</p>
    </div>
  </div>
</div>

<div mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" (click)="printReport()" (keydown.enter)="printReport()"
    [disabled]="this.selectedTools?.length === 0">
    Preview/Print/File Report
  </button>
  <button mat-dialog-close mat-raised-button>Cancel</button>
</div>